import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import styled, { keyframes } from "styled-components";
import { extendedSystemStylesProps, extendedSystemStyles, subText } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var styledSystemKeys = ["space", "layout", "flexbox"];
var spin = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var backwardsSpin = keyframes(["0%{transform:rotate(360deg);}100%{transform:rotate(0deg);}"]);
var Container = styled.div.withConfig({
  displayName: "LoadingWithSpinner__Container",
  componentId: "sc-uy3bzx-0"
})(["", "", ""], function (_ref) {
  var theme = _ref.theme;
  return "\n    display: flex;\n    align-items: center;\n    p{\n     ".concat(subText(theme), "\n      margin: 10px 0;\n      white-space: nowrap;\n    }\n  ");
}, extendedSystemStyles(styledSystemKeys));
var Loader = styled.div.withConfig({
  displayName: "LoadingWithSpinner__Loader",
  componentId: "sc-uy3bzx-1"
})(["animation:", " 1.2s linear infinite;", ""], spin, function (_ref2) {
  var theme = _ref2.theme,
    inverted = _ref2.inverted;
  return "\n    border: 3px solid transparent;\n    border-top: 3px solid ".concat(inverted ? theme.colors.G1 : theme.colors.P3, ";\n    border-bottom: 3px solid ").concat(inverted ? theme.colors.G1 : theme.colors.P3, ";\n    border-radius: 50%;\n    width: 2.4rem;\n    height: 2.4rem;\n    margin-top: -3px;\n    transform: translateZ(0);\n  ");
});
var InnerLoader = styled.div.withConfig({
  displayName: "LoadingWithSpinner__InnerLoader",
  componentId: "sc-uy3bzx-2"
})(["animation:", " 1.2s linear infinite;", ""], backwardsSpin, function (_ref3) {
  var theme = _ref3.theme;
  return "\n    position: absolute;\n    top: 0;\n    left: 3px;\n    border: 3px solid transparent;\n    border-left: 3px solid ".concat(theme.colors.i1, ";\n    border-right: 3px solid ").concat(theme.colors.i1, ";\n    border-radius: 50%;\n    width: 1.8rem;\n    height: 1.8rem;\n    transform: translateZ(0);\n");
});
var LoadingWithSpinner = function LoadingWithSpinner(props) {
  var label = props.label,
    hideLabel = props.hideLabel,
    inverted = props.inverted,
    className = props.className;
  return /*#__PURE__*/_jsxs(Container, _objectSpread(_objectSpread({
    className: className
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        position: "relative",
        marginRight: "6px"
      },
      children: [/*#__PURE__*/_jsx(Loader, {
        inverted: inverted
      }), /*#__PURE__*/_jsx(InnerLoader, {})]
    }), /*#__PURE__*/_jsx("p", {
      className: hideLabel ? "hidden-styles" : "",
      children: label
    })]
  }));
};
LoadingWithSpinner.propTypes = {
  label: PropTypes.string.isRequired,
  inverted: PropTypes.bool,
  className: PropTypes.string
};
export default LoadingWithSpinner;